<template>
  <swiper :options="swiperOption" @slideChange="onSlideChange" ref="attachSwiper" >
    <swiper-slide v-for="(fileItem,i) in attachments" :key="i" class="swiper-lazy">
      <img v-if="isPicAttachment(fileItem)" :src="fileItem.file" class="image">
      <video-player v-else-if="isVideoAttachment(fileItem)"
                    ref="slidePlayer"
                    :id="i"
                    :source="fileItem.file"/>
      <div v-else class="no-pic">
        <a :href="fileItem.file" target="_blank" class="no-pic-link">
          <md-icon class="md-size-5x">
            {{ getIconByFileType(fileItem.file) }}
          </md-icon>
          <span>Открыть</span>
        </a>
      </div>
      <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="swiper-button-prev" slot="button-prev">
      <md-icon class="md-size-2x">
        keyboard_arrow_left
      </md-icon>
    </div>
    <div class="swiper-button-next" slot="button-next">
      <md-icon class="md-size-2x">
        keyboard_arrow_right
      </md-icon>
    </div>
  </swiper>
</template>

<script>
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import { isPicAttachment, isVideoAttachment } from '@/services'
  import { getIconByFileType } from '@/utils'
  import VideoPlayer from '@/components/Custom/VideoPlayer'
  export default {
    name: "AttachmentSlider",
    components: {
      swiper,
      swiperSlide,
      VideoPlayer
    },
    data() {
      return {
        swiperOption: {
          lazy: true,
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          initialSlide: this.initialSlideNumber,
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            renderFraction: function (currentClass, totalClass) {
              return '<span class="custom-current ' + currentClass + '"></span>' +
                '<span class="custom-of">из</span>' +
                '<span class="custom-total ' + totalClass + '"></span>';
            },
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
      }
    },
    props: {
      initialSlideNumber: {
        type: Number,
        default: 0,
      },
      attachments: {
        type: Array,
        default: null,
      }
    },
    computed: {
      slider() {
        return this.$refs.attachSwiper.swiper;
      }
    },
    methods: {
      isPicAttachment,
      isVideoAttachment,
      getIconByFileType,

      onSlideChange() {
        if (this.$refs.slidePlayer) {
          this.$refs.slidePlayer.forEach((playerComponent) => {
            playerComponent.player.pause()
          })
        }

      }
    },
    beforeDestroy() {
      if (this.slider) {
        this.slider.destroy(true, false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/md/_variables.scss";

  .swiper-container {
    width: 100%;
    max-width: 1000px;
    height: 500px;
  }
  .image {
    height: 100%;
  }
  .no-pic {
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &-link {
      display: flex;
      flex-direction: column;
    }
  }
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-slide img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
    left: 50%;
    top: 50%;
  }

  .swiper-button-prev,
  .swiper-button-next {
    background-image: none;
    background-color: #0a0a0a7a;
    width: 50px;
    height: 50px;
    text-align: center;
    border-radius: 50%;
  }


  @media (max-width: $screen-lg) {
    .swiper-container {
      max-width: 700px;
    }
  }

  @media (max-width: $screen-md) {
    .swiper-container {
      max-width: 445px;
    }
  }

  @media (max-width: $screen-xs) {
    .swiper-container {
      max-width: 345px;
    }
  }

</style>
<style lang="scss">
  .custom-current,
  .custom-of,
  .custom-total {
    background-color: #0a0a0a7a !important;
    color: #ffffff;
  }

  .custom-current {
    border-radius: 10px 0 0 10px;
    padding: 2px 2px 2px 4px;
  }

  .custom-of {
    padding: 2px;
  }
  .custom-total {
    border-radius: 0 10px 10px 0;
    padding: 2px 4px 2px 2px;
  }
</style>
